import { ApolloClient, ApolloLink, InMemoryCache } from "@apollo/client";
import { createUploadLink } from 'apollo-upload-client';
import { setContext } from '@apollo/client/link/context';
import { apiRequest, loginRequest } from "./authConfig";
import { acquireToken, credential, account, requestLogin } from "./authContext";

const apiKey = process.env.REACT_APP_BACKEND_KEY;
const cache = new InMemoryCache();

const uploadLink = createUploadLink({ uri: `${process.env.REACT_APP_BACKEND_URL}/graphql`});

const authLink = setContext(async (_, { headers }) => {
  const user = account();
  const token = credential();
  let result;
  if (token?.idToken && user.homeAccountId){
    try {
      result = await acquireToken({ ...apiRequest, account: user });
    } catch (err: any) {
      console.error('apolloClient aquireToken failure', err);
      await requestLogin(loginRequest,'loginRedirect');
    }
  } else {
      result = { idToken: '', accessToken: '' };
  }
  const { idToken, accessToken } = result;
  return {
    headers: {
      ...headers,
      authorization: idToken ? `Bearer ${idToken}` : "",
      accesstoken: accessToken,
      'X-Ducks-Volunteer-Subscription-Key': apiKey,
    }
  }
});
const link = ApolloLink.from([ authLink, uploadLink]);
const apolloClient = new ApolloClient({
  cache,
  link,
});

export default apolloClient; 
